import React, { Component } from "react";
import PropTypes from "prop-types";
import ChatIcon from "./ChatIcon";

class AdvisorsBusy extends Component {
  render() {
    return /*#__PURE__*/React.createElement("div", {
      id: "queue-view"
    }, /*#__PURE__*/React.createElement("div", {
      className: "header"
    }, /*#__PURE__*/React.createElement(ChatIcon, {
      className: "large"
    }), /*#__PURE__*/React.createElement("span", {
      className: "dpd-customer-services"
    }, "DPD Customer Services")), /*#__PURE__*/React.createElement("div", {
      className: "message wide-message"
    }, "All of our advisors are busy at the moment.", !this.props?.hideEmailByAdvisorsBusy && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), "You can try again later or to send us an email please", " ", /*#__PURE__*/React.createElement("a", {
      href: `mailto:${!this.props.queue || this.props.queue === "Elite" ? "elite@dpd.co.uk" : "platinum@dpd.co.uk"}`
    }, "click here"))), /*#__PURE__*/React.createElement("div", {
      id: "leave-queue",
      style: {
        visibility: "hidden"
      }
    }, /*#__PURE__*/React.createElement("button", {
      onClick: this.props.onLeave
    }, "Close chat"), /*#__PURE__*/React.createElement("button", {
      className: "flat-white-reverse",
      onClick: this.props.onBack
    }, "Return to chat")));
  }

}

AdvisorsBusy.propTypes = {
  hideEmailByAdvisorsBusy: PropTypes.bool,
  queue: PropTypes.string,
  onLeave: PropTypes.func,
  onBack: PropTypes.func
};
export default AdvisorsBusy;